export const PAGE_KEYS = {
  DASHBOARD: 'DASHBOARD',
  EQUIPMENT: 'EQUIPMENT',
  BLOCK_SCHEDULE: 'BLOCK_SCHEDULE',
  PLANS: 'PLANS',
  TASKS: 'TASKS',
  PHOTOS: 'PHOTOS',
  FORMS: 'FORMS',
  FILES: 'FILES',
  PROJECT_USERS: 'PROJECT_USERS',
  TEMPLATES: 'TEMPLATES',
  SETTINGS: 'SETTINGS'
} as const;

export const PERMISSION_KEYS = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  TEMPLATE_CONFIG: 'TEMPLATE_CONFIG',
  SKID_SPEC: 'SKID_SPEC',
  CHANGE_SHIP_DATE: 'CHANGE_SHIP_DATE',
  EXPORT: 'EXPORT',
  BULK_UPDATE: 'BULK_UPDATE',
  SAVE: 'SAVE',
  SEND_EMAIL: 'SEND_EMAIL',
  SUBMIT: 'SUBMIT',
  IMPORT: 'IMPORT',
  PUBLISH: 'PUBLISH',
  UPLOAD: 'UPLOAD',
  OVERRIDE_STATUS: 'OVERRIDE_STATUS',
  MES_DATA: 'MES_DATA',
  REPORT: 'REPORT',
  ASSIGN: 'ASSIGN',
  CUSTOMER_CARD: 'CUSTOMER_CARD',
  TMCA_INFO_CARD: 'TMCA_INFO_CARD',
  CHECKLIST_CARD: 'CHECKLIST_CARD',
  COMPLETION_BY_PHASE: 'COMPLETION_BY_PHASE',
  PROJECT_SPECIFIC_ACTIVE_USERS: 'PROJECT_SPECIFIC_ACTIVE_USERS',
  INTEGRATION_PROGRESS: 'INTEGRATION_PROGRESS',
  CUSTOMER_PROGRESS: 'CUSTOMER_PROGRESS',
  COMMISSIONING_PROGRESS: 'COMMISSIONING_PROGRESS',
  MAN_HOURS: 'MAN_HOURS',
  EQUIPMENT_PROGRESS_GRAPH: 'EQUIPMENT_PROGRESS_GRAPH',
  TOP_RECURRING_FAILURE: 'TOP_RECURRING_FAILURE',
  WMR_DSR_WILDLIFE: 'WMR_DSR_WILDLIFE',
  NCR: 'NCR',
  CUMULATIVE_HOURS_PER_USER: 'CUMULATIVE_HOURS_PER_USER',
  HOURS_ALLOCATION_BY_CATEGORY: 'HOURS_ALLOCATION_BY_CATEGORY',
  HOURS_ALLOCATION_BY_SKID: 'HOURS_ALLOCATION_BY_SKID'
} as const;
